import { BudgetAPI, ConfigurationAPI } from "@griffingroupglobal/eslib-api";
import { COA_CODE_TYPES } from "../constants";
import {
  formatGroupDropdownForBudgetTable,
  formatLineitem,
} from "../helpers/Budget";

export const getBudgetLineItems = async (budgetId, pullSummary) => {
  let budgetData;

  if (pullSummary) {
    const { data } = await BudgetAPI.getWOP(`${budgetId}/$summary`);
    budgetData = data;
  } else {
    const { data } = await BudgetAPI.getById(budgetId);
    budgetData = data;
  }

  const { data } = await ConfigurationAPI.getById("financials");
  const groups = formatGroupDropdownForBudgetTable(budgetData.groups);

  // Create kep-value pairs for fast search
  const csiCodeMappingObject = {};

  const revenueAccountingCodes = data?.financials?.chartOfAccounts?.filter(
    (code) => code.codeType === COA_CODE_TYPES[1].value
  );

  const expenseAccountingCodes = data?.financials?.chartOfAccounts?.filter(
    (code) => code.codeType === COA_CODE_TYPES[0].value
  );

  data?.financials?.csiCodeMapping.forEach((div) => {
    div?.csiCodes.forEach((csi) => {
      csi?.subCodes.forEach((sub) => {
        const finalKey = `${div.division} ${csi.code} ${sub.code}`;
        let finalDescription = sub.description;
        if (sub.revenueCode) {
          finalDescription = revenueAccountingCodes?.find(
            (revenueCode) => revenueCode.code === sub?.revenueCode
          )?.description;
        } else if (sub.expenseCode) {
          finalDescription = expenseAccountingCodes?.find(
            (expenseCode) => expenseCode.code === sub?.expenseCode
          )?.description;
        }
        csiCodeMappingObject[finalKey] = finalDescription;
      });
    });
  });

  const divisionsObject = {};
  data?.financials?.csiCodeMapping?.forEach((div) => {
    divisionsObject[div.division] = `${div.division} - ${div.description}`;
  });

  const financialsConfiguration = {
    financials: {
      ...data?.financials,
      csiCodeMappingObject,
      divisionsObject,
    },
  };

  return {
    budget: budgetData,
    lineItems: budgetData.lineItems.map((li) =>
      formatLineitem(
        li,
        financialsConfiguration?.financials?.divisionsObject,
        financialsConfiguration?.financials?.csiCodeMappingObject,
        groups
      )
    ),
  };
};

export const getBudget = async (budgetId) => {
  const { data } = await BudgetAPI.getById(budgetId);
  return data;
};
